import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className='container my-5'>
      <h2 className="body-font-bold mb-4 fs-3">Privacy Policy</h2>
      <p className="mb-4">
        At <strong>PENTADECO.IN</strong>, we are committed to safeguarding your privacy. 
        This Privacy Policy explains how we collect, use, and protect your information 
        when you use our website <a href="https://pentadeco.in" target='_blank' rel="noreferrer" className="nav-link d-inline text-primary">www.pentadeco.in</a>. 
        By accessing or purchasing from our site, you agree to the practices outlined below.
      </p>

      <div className="content">
        <ol className='m-0'>
          <li className='mb-4'>
            <p className="fs-5 body-font-medium">Information We Collect</p>
            <ol className='m-0' type='I'>
              <li>
                <p className="text-muted">
                  <span className='body-font-medium text-black'>Personal Information:</span> 
                  Name, email address, phone number, shipping/billing address, and payment details (securely processed via third-party gateways).
                </p>
              </li>
              <li>
                <p className="text-muted">
                  <span className='body-font-medium text-black'>Non-Personal Information:</span> 
                  IP address, browser type, device details, and browsing activity for analytics and site improvements.
                </p>
              </li>
              <li>
                <p className="text-muted">
                  <span className='body-font-medium text-black'>Cookies:</span> 
                  We use cookies to enhance user experience, store preferences, and analyze traffic. 
                  You may control cookies via your browser settings.
                </p>
              </li>
            </ol>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">How We Use Your Information</p>
            <ol className='m-0' type='I'>
              <li><p className="text-muted"><span className='body-font-medium text-black'>Order Fulfillment:</span> Processing, shipping, and delivering your purchases.</p></li>
              <li><p className="text-muted"><span className='body-font-medium text-black'>Communication:</span> Sending order updates, responding to inquiries, and providing support. With consent, promotional offers may also be sent.</p></li>
              <li><p className="text-muted"><span className='body-font-medium text-black'>Improvement:</span> Analyzing data to enhance our services and customer experience.</p></li>
              <li><p className="text-muted"><span className='body-font-medium text-black'>Legal Compliance:</span> Ensuring obligations under Indian law including the DPDP Act 2023 are met.</p></li>
            </ol>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">Data Sharing</p>
            <ol className='m-0' type='I'>
              <li><p className="text-muted"><span className='body-font-medium text-black'>Logistics & Payment Partners:</span> To deliver orders and process payments securely.</p></li>
              <li><p className="text-muted"><span className='body-font-medium text-black'>Legal Authorities:</span> If required by applicable laws or to prevent fraud.</p></li>
              <li><p className="text-muted"><span className='body-font-medium text-black'>Business Transfers:</span> In case of mergers, acquisitions, or restructuring.</p></li>
            </ol>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">Your Rights</p>
            <p className="text-muted">
              You have the right to access, update, correct, or delete your personal data. 
              You may also withdraw consent for marketing communications. For requests, email us at <a href="mailto:pentadeco@gmail.com" className="nav-link d-inline text-primary">pentadeco@gmail.com</a>.
            </p>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">Data Security</p>
            <p className="text-muted">
              We use SSL encryption and industry-standard measures to protect data. 
              However, no method of transmission over the Internet is 100% secure.
            </p>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">Children’s Privacy</p>
            <p className="text-muted">
              Our website is intended for users aged 18 and above. 
              We do not knowingly collect data from children under 18. 
              If found, such data will be deleted promptly.
            </p>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">International Data Transfer</p>
            <p className="text-muted">
              Data may be stored or processed outside India (e.g., cloud servers). 
              By using our services, you consent to such transfers in line with Indian law.
            </p>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">Policy Updates</p>
            <p className="text-muted">
              We may revise this Privacy Policy as required. 
              Updates will be posted with a “Last Updated” date.
            </p>
          </li>

          <li className='mb-4'>
            <p className="fs-5 body-font-medium">Contact Information</p>
            <p className="text-muted">If you have questions or concerns, contact us:</p>
            <p className="mb-0">Pentadeco Customer Service</p>
            <p className="mb-0">Email: <a href="mailto:pentadeco@gmail.com" className="nav-link d-inline text-primary">pentadeco@gmail.com</a></p>
            <p className="mb-0">WhatsApp: <a href="tel:+917738494171" className="nav-link d-inline text-primary">+91 77384 94171</a> | 
              <a href="tel:+918433551012" className="nav-link d-inline text-primary"> +91 84335 51012</a> | 
              <a href="tel:+919273158535" className="nav-link d-inline text-primary"> +91 92731 58535</a></p>
          </li>
        </ol>
      </div>
    </div>
  )
}

export default PrivacyPolicy;
